import { createApiRef } from '@backstage/core-plugin-api';
import { pluginConfig } from '../config';

export const ApiRef = createApiRef<Api>({
  id: `plugin.${pluginConfig.pluginId}.service`,
});

export interface Api {
  /**
   * Returns the metrics for a component.
   * @param componentName The name of the component to get metrics for.
   */
  getComponentMetrics(componentName: string): Promise<any>;
}
